import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { localGet } from '@/config/storage'
import { ElMessage } from 'element-plus'
import store from '@/store'

const routes : Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'index',
		redirect: '/home/overview',
	},
	{
		path: '/home/overview',
		name: 'home',
		component: () => import('../views/home/index.vue'),
		meta: {
			title: '概览',
			needToken: true,
			module: 'home',
			showLeftMenu: true,
			showNav: true,
			showBread: false,
		}
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('../views/login/login.vue'),
		meta: {
			title: '登录',
			module: 'login',
			showLeftMenu: false,
			showNav: false,
		}
	},
	{
		path: '/html/:url?',
		name: 'html',
		props: true,
		component: () => import('../views/html/Html.vue'),
		meta: {
			title: ' ',
			module: 'login',
			showLeftMenu: false,
			showNav: false,
			needToken: false
		}
	},
	{
	    name: 'device',
	    path: '/device',
	    component: () => import('@/views/device/Device.vue'),
	    meta: {
	        title: '设备',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'device'
	    }
	},
	{
	    name: 'deviceMaintenance',
	    path: '/deviceMaintenance',
	    component: () => import('@/views/deviceMaintenance/deviceMaintenance.vue'),
	    meta: {
	        title: '设备运维',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'device'
	    }
	},
	{
	    name: 'mallManagement',
	    path: '/mallManagement',
	    component: () => import('@/views/mallManagement/mallManagement.vue'),
	    meta: {
	        title: '商城管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'device'
	    }
	},
	{
	    name: 'marketingContent',
	    path: '/marketingContent',
	    component: () => import('@/views/marketingContent/marketingContent.vue'),
	    meta: {
	        title: '宣传文案',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'device'
	    }
	},
	{
	    name: 'scene',
	    path: '/scene',
	    component: () => import('@/views/scene/Scene.vue'),
	    meta: {
	        title: '场景',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'scene'
	    }
	},
	{
	    name: 'log',
	    path: '/log',
	    component: () => import('@/views/log/Log.vue'),
	    meta: {
	        title: '日志',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'log'
	    }
	},
	{
	    name: 'personal',
	    path: '/personal',
	    component: () => import('@/views/personal/Personal.vue'),
	    meta: {
	        title: '个人中心',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'log'
	    }
	},
	{
	    name: 'user',
	    path: '/user',
	    component: () => import('@/views/user/User.vue'),
	    meta: {
	        title: '用户管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'log'
	    }
	},
	{
	    name: 'family',
	    path: '/family',
	    component: () => import('@/views/family/Family.vue'),
	    meta: {
	        title: '家庭管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'log'
	    }
	},
	{
	    name: 'product',
	    path: '/product',
	    component: () => import('@/views/product/Product.vue'),
	    meta: {
	        title: '产品管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'log'
	    }
	},
	{
	    name: 'notice',
	    path: '/notice',
	    component: () => import('@/views/notice/Notice.vue'),
	    meta: {
	        title: '通知发布',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'notice'
	    }
	},
	{
	    name: 'role',
	    path: '/role',
	    component: () => import('@/views/role/Role.vue'),
	    meta: {
	        title: '角色管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'role'
	    }
	},
	{
	    name: 'firmware',
	    path: '/firmware',
	    component: () => import('@/views/firmware/Firmware.vue'),
	    meta: {
	        title: '固件管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'firmware'
	    }
	},
	{
	    name: 'SMS',
	    path: '/SMS',
	    component: () => import('@/views/sms/Sms.vue'),
	    meta: {
	        title: '短信服务',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'SMS'
	    }
	},
	{
	    name: 'applet',
	    path: '/applet',
	    component: () => import('@/views/applet/Applet.vue'),
	    meta: {
	        title: '短信服务',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'applet'
	    }
	},
	{
	    name: 'platform',
	    path: '/platform',
	    component: () => import('@/views/platform/Platform.vue'),
	    meta: {
	        title: '短信服务',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'platform'
	    }
	},
	{
	    name: 'media',
	    path: '/media',
	    component: () => import('@/views/media/Media.vue'),
	    meta: {
	        title: '媒体管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'media'
	    }
	},
	{
	    name: 'fileStorage',
	    path: '/fileStorage',
	    component: () => import('@/views/fileStorage/FileStorage.vue'),
	    meta: {
	        title: '文件存储服务',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'fileStorage'
	    }
	},
	{
	    name: 'panel',
	    path: '/panel',
	    component: () => import('@/views/panel/Panel.vue'),
	    meta: {
	        title: '面板管理',
	        showBread: true,
	        showNav: true,
	        showLeftMenu: true,
			needKeep: true,
	        module: 'panel'
	    }
	},
	{
	    name: 'tutorial',
	    path: '/tutorial/:id',
		props: true,
	    component: () => import('@/views/tutorial/tutorial.vue'),
	    meta: {
	        title: '视频教程',
	        showBread: false,
	        showNav: false,
	        showLeftMenu: false,
			needKeep: false,
	        module: 'tutorial',
			needToken: false
	    }
	}
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

router.beforeEach((to, _, next) => {
	const token = localGet('token')
	if(token){
		if (to.meta.title == '登录') {
			next('/')
		} else {
			next()
		}
	}else{
		if (to.meta.needToken) {
			ElMessage.error('请先登录')
			next('/login')
		} else {
			next()
		}
	}
})
router.afterEach(to => {
	let title = store.state?.publicOptions.platformInfo.systemName
	if(to.meta.title){
		title = String(to.meta.title)
	}
	document.title = title
})

export default router